//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var FastClick = require('fastclick');
// FastClick.attach(document.body);
import { mapGetters, mapMutations } from 'vuex'
import loading from './components/common/loading'
import feedback from './components/common/feedback'
import encode from './server/api/encode'

export default {
  name: 'app',
  components: {
    loading,
    feedback
  },
  computed: {
    ...mapGetters(['isWeChat', 'placeSource', 'uid', 'session', 'version', 'guid', 'system']),
    show() {
      return this.$store.state.base.loading
    },
    mask() {
      return this.$store.state.base.mask
    },
    feedbackVisible() {
      return this.$store.state.base.feedbackVisible
    }
  },
  methods: {
    ...mapMutations([
      'showLoad', 'hideLoad', 'setBaseInfo'
    ]),
    /** ios 用户信息的回调函数 */
    iosUserInfoCacllBack(obj) {
      console.log(obj)
      let iosCallbackInfo = decodeURIComponent(obj)
      let localInfo = JSON.parse(encode.decodeFuc(iosCallbackInfo))
      console.log(localInfo, 'ios 回调的用户信息')
      if (localInfo.uid != self.uid) {
        this.setBaseInfo(localInfo)
      }
    }
  },
  created() { },
  mounted() {
    modifySharePlatforms('3,4,5')
    // AppBaseInfoSave(this.iosUserInfoCacllBack);
  }
}



// WEBPACK FOOTER //
// ./src/App.vue